var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{attrs:{"src":require(`@/assets/img/pbi/${_vm.name}.svg`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }